"use client";

import { useMemo } from "react";
import { Scopes } from "../core/hash";
import { SessionType } from "../core/types";
import { useSession } from "./use-session";

export function useUploads(subject: string | undefined, scopes?: Scopes) {
	const { session } = useSession(subject, SessionType.Upload, scopes);

	console.log("use uploads hook: ", session?.items, session);

	return useMemo(() => session?.items ?? [], [session]);
}
